import React from 'react';
import PermissionMatrix from './PermissionMatrix';

const Commercial = (props) => (
  <PermissionMatrix {...props} areaLabel="Comercial" hierarchy={['Diretor', 'Treinador', 'Planejador']} />
);

export default Commercial;
